import { useEffect } from 'react';
import { PrivateAxios } from '../../request/axios';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const logoutUser = async () => {
            try {
                // Appel à l'API pour déconnexion côté backend
                await PrivateAxios.get('/logout', {
                    withCredentials: true,
                });
            } catch (error) {
                console.error('Erreur lors de la déconnexion:', error);
            } finally {
                localStorage.removeItem('assistance-axa-token');
                navigate('/login', {state : {'message': location.state?.message}});
            }
        };

        logoutUser();
    }, [navigate, location]);

    return null;
};

export default Logout;
